import { Alert } from "@hightouch/htui";

import { useCepWorkspaceConfig } from "src/cep/use-cep-workspace-config";
import { useLocation } from "src/router";

import { isInSandboxBannerSection } from "./sandbox-banner-scope";

type Props = {
  parentModelId?: number | null;
};

export function SandboxBanner({ parentModelId }: Props = {}) {
  const { pathname } = useLocation();
  const isInScope = isInSandboxBannerSection(pathname);

  // Mounted on every page; the query isn't in `preservedQueryKeys`, so an active
  // copy would refetch after every mutation in the app.
  const { config } = useCepWorkspaceConfig({ enabled: isInScope });

  if (!isInScope) return null;

  if (config?.mode !== "sandbox") return null;

  if (
    parentModelId != null &&
    String(config.parent_model?.id) !== String(parentModelId)
  ) {
    return null;
  }

  return (
    <Alert
      variant="inline"
      type="info"
      title='Native Delivery "sandbox mode" is enabled in this workspace. Sends will be simulated for all channels.'
      mt={2}
      mr={2}
    />
  );
}
